import { AllPayload, PartSold, technicianRepository, PartSoldApiCollection } from '@/store/modules';
import { PartSoldState } from '@/store/types';
// import {taskRepository} from './repository';
import { normalizeError } from '@/utility';
import { Action, Module, VuexModule } from 'vuex-module-decorators';
import { partSoldRepository } from './repository';
import { AxiosResponse } from 'axios';

const insertFromResponseCollection = async (response: AxiosResponse<PartSoldApiCollection>) => {
  if (response.status < 200 && response.status >= 300) {
    console.error('Invalid 2XX response status');
    throw `Invalid response code: ${response.status}`;
  }

  const data = response.data;

  // todo: create toggle? instead of just inserting
  if (data.results) {
    await PartSold.insert({
      data: data.results.map((data) => {
        if ('info' in data) {
          data['part'] = data['info'];
        }

        return data;
      })
    });
  }

  PartSold.commit(state => {
    state.fetching = false;
  });
}

@Module
export class PartSoldModule extends VuexModule implements PartSoldState {
  // fetching: boolean = false;

  @Action
  async all(payload: AllPayload) {
    PartSold.commit(state => {
      state.fetching = true;
      state.error.length = 0;
    });

    try {
      const { status, data } = await partSoldRepository.all(payload);

      if (status < 200 && status >= 300) {
        console.error('Invalid 2XX response status');
        throw `Invalid response code: ${status}`;
      }

      if (!data || !data.results) {
        console.error('Invalid data status codes');
        throw 'Invalid response payload.'
      }

      const { results, total } = data;
      await PartSold.create({
        data: results
      });

      PartSold.commit(state => {
        state.fetching = false;
        state.total = +total;
      });

    } catch (err) {
      const e = (normalizeError(err) || err);

      PartSold.commit(state => {
        state.fetching = false;
        state.total = 0;
        state.error.push(e);
      });
      // throw e;
    }

  }

  @Action
  async findOne(payload: { id: number }) {
    // this.context.commit('fetching', true);
    PartSold.commit(state => {
      state.fetching = true;
      state.error.length = 0;
    });

    try {
      const response = await partSoldRepository.findOne(payload.id);

      if (response.status < 200 && response.status >= 300) {
        console.error('Invalid 2XX response status');
        throw `Invalid response code: ${response.status}`;
      }

      const data = response.data;

      await PartSold.insert({
        data
      });

      PartSold.commit(state => {
        state.fetching = false;
      });

    } catch (err) {
      console.error(err);
      // normalizeError
      const e = (normalizeError(err) || err);
      PartSold.commit(state => {
        state.fetching = false;
        state.error.push(e);
      });
    }

    // this.context.commit('fetching', false);
  }

  @Action
  async findByMR(payload: { recordId: number }) {
    PartSold.commit(state => {
      state.fetching = true;
      state.error.length = 0;
    });

    try {
      const { recordId, ...params } = payload;

      const response = await partSoldRepository.findByMR(recordId, params);

      await insertFromResponseCollection(response);
    } catch (err) {
      console.error(err);
      // normalizeError
      const e = (normalizeError(err) || err);
      PartSold.commit(state => {
        state.fetching = false;
        state.error.push(e);
      });
    }
  }

  @Action
  async findByPart(payload: { partId: number }) {
    PartSold.commit(state => {
      state.fetching = true;
      state.error.length = 0;
    });

    try {
      const { partId, ...params } = payload;

      const response = await partSoldRepository.findByPart(partId, params);

      await insertFromResponseCollection(response);
    } catch (err) {
      console.error(err);
      // normalizeError
      const e = (normalizeError(err) || err);
      PartSold.commit(state => {
        state.fetching = false;
        state.error.push(e);
      });
    }
  }
}

export default PartSoldModule;
// export default getModule(PartSoldModule);